import * as React from 'react';

const EyeOffSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="eye-off_svg__eds-icon--eye-off_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="eye-off_svg__eds-icon--eye-off_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M17 16.7l-.8-.7-1.6-1.6-.6-.8-3.4-3.5-.7-.7L8.5 8l-.7-.7L4.6 4l-.7.7 3 3.1C4 9.6 2 12.3 2 12.3s4.4 6.1 9.9 6.1c1.5 0 2.9-.4 4.1-1.1l3.2 3.3.7-.7-2.9-3.2zm-7.1-5.8l3.4 3.5c-.4.3-.8.4-1.3.4-1.4 0-2.5-1.1-2.5-2.5 0-.5.1-1 .4-1.4m2 6.4c-3.9 0-7.4-3.6-8.6-5.1.8-.9 2.3-2.6 4.3-3.7l1.6 1.6c-.4.6-.7 1.3-.7 2.1 0 2 1.5 3.6 3.5 3.6.8 0 1.5-.3 2.1-.7l1.3 1.4c-1.1.5-2.3.8-3.5.8"
        />
        <path
            id="eye-off_svg__eds-icon--eye-off_eye"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M11.9 6.2c-1.1 0-2.2.3-3.2.6l.8.8c.8-.3 1.6-.4 2.4-.4 3.9 0 7.4 3.6 8.6 5.1-.6.8-1.9 2.1-3.4 3.2l.7.7c2.4-1.7 4-3.9 4-3.9s-4.4-6.1-9.9-6.1z"
        />
        <path
            id="eye-off_svg__eds-icon--eye-off_pupil"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M15.2 13.4c.1-.4.2-.8.2-1.2 0-2-1.5-3.6-3.5-3.6-.4 0-.8.1-1.1.2l.8.9h.3c1.4 0 2.5 1.1 2.5 2.5v.3l.8.9z"
        />
    </svg>
);

EyeOffSvg.displayName = 'EyeOffSvg';
export default EyeOffSvg;
